//Original with ReactDom.render
import React, { useState, useMemo, useRef, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Skeleton from '@material-ui/lab/Skeleton';
import Chip from '@material-ui/core/Chip';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { LFTooltip, HtmlTooltip } from './../Tooltips';

// import React-Redux
import { useSelector, useDispatch } from 'react-redux';
import * as issueActions from './../../../actions/issue.action';
import * as issueCommentActions from './../../../actions/issueComment.action';
import * as issueLogActions from '../../../actions/issueLog.action';

// import react-router-dom
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { routers } from './../../../routers';

import { useHandleClientError } from './../../../utils/HttpClient';

// import useSnackbar
import { useSnackbar } from 'notistack';

// import constants
import { server } from './../../../constants';

// import style
import { chipStyles } from './../../../styles/globalStyles/dataDisplayStyles';

// import utils
import {
  logger,
  base64,
  userProfiler,
  issueOperations,
  isManageIssue,
} from './../../../utils/utils';

// import another fragment
import ButtonGroupSelectOptions from '../ButtonGroupSelectOptions';
import { LabelPicker } from './../LabelPicker';
import AutocompleteSelectOptions from '../AutocompleteSelectOptions';
import { FormForwardIssueDialog } from './../../fragments/FormDialogs';
import { ChipLabels } from './../LabelPicker';

import {
  useProcessStatusGetList,
  useProcessStatusGetListAll,
  useDimensionGetListAll,
} from './../../../hooks/useData';

const styles = (theme) => ({
  ...chipStyles(theme),
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  section1: {
    margin: theme.spacing(1.7),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
});

function issueTransition(data) {
  return data ? data : '';
}

const SkeletonText = withStyles(styles)(({ classes }) => {
  return (
    <div className={classes.section1}>
      <Skeleton width="90%" variant="text" />
      <Skeleton width="80%" variant="text" />
      <Divider variant="middle" />
    </div>
  );
});
/**
 * AppSidebarRBackManageIssueActivity: App in Sidebar-Right of Back-Office
 */
const AppSidebarRBackManageIssueActivity = withStyles(styles)(
  ({ classes, match }) => {
    logger('AppSidebarRBack render');

    const issue_id = base64.decode(match.params.id);

    // Get user profile
    const upf = useMemo(() => userProfiler.getFromLocal(), []);

    // Hook handle-client-error (handle error in catch from promise reject)
    const handleClientError = useHandleClientError();

    // States
    const [openFormForward, setOpenFormForward] = useState(false);

    const btnSelectOptionsRef = useRef();

    // Hook states in reducer (by useSelector) from store
    const dispatch = useDispatch();
    const issueReducer = useSelector(({ issueReducer }) => issueReducer);

    // Check empty issueReducer.result assign to initail issue
    let issue = issueReducer.result || {};

    let isManageFeatures = issue.issues
      ? isManageIssue(
          issue.readOnlyStatus.readOnly,
          issue.issues.worker === upf.user.id,
          issue.issues.processStatus_id,
          {
            operation: issueOperations.features,
          }
        )
      : false;

    // Hook enqueueSnackbar from useSnackbar
    const { enqueueSnackbar } = useSnackbar();

    // package parameter for request getDetail-issue
    const memoGetIssueDetailPackage = useMemo(
      () => ({
        package: base64.encodeObj({
          lang: 'TH',
          id: issue_id,
        }),
      }),
      [issue_id]
    );

    // package parameter for request getList-comment
    const memoGetListActivityPackage = useMemo(
      () => ({
        package: base64.encodeObj({
          lang: 'TH',
          mode: server.REQ_PARAM_MODE_STAFF,
          issue_id,
        }),
      }),
      [issue_id]
    );

    const processStatusesBiz = useProcessStatusGetList(
      'TH',
      issue_id,
      issue.issues && issue.issues.processStatus_id
    );

    const processStatuses = useProcessStatusGetListAll('TH');

    const dimensions = useDimensionGetListAll('TH');

    /*******************************
     * PROCESS-STATUS APP FUCNTION
     *******************************/

    /**
     * handleChangeProcessStatus()
     * @param {object} props
     * @param {string} props.processStatus_id
     * @param {string} props.processStatus_name
     */
    const handleChangeProcessStatus = async ({ id, name, description }) => {
      // Set processStatus_idRef temp
      let status_id = id;
      if (status_id === 40) {
        setOpenFormForward(true);
      } else {
        try {
          // // Dispatch mutiple action solution 1
          // await dispatch(async (dispatch) => {
          //   // https://react-redux.js.org/api/batch
          //   // should only result in one combined re-render, not two
          //   await batch(async () => {
          //     // Original dispatch action (of handleChangeProcessStatus)
          //     await dispatch(
          //       issueActions.updateProcessStatus(
          //         { issue_id, status_id },
          //         {
          //           package: base64.encodeObj({
          //             lang: 'TH',
          //             id: issue_id,
          //           }),
          //         }
          //       )
          //     );
          //     // Addition: dispatch action-updateIssueLog
          //     await dispatch(
          //       issueLogActions.updateIssueLog(memoGetListActivityPackage)
          //     );
          //   });
          // });

          // Dispatch mutiple action (updateIssue, updateIssueLog) solution 2
          // Ref: https://github.com/reduxjs/redux-thunk
          // Ref: https://twitter.com/dan_abramov/status/770914221638942720
          // FIXME: Maybe code dispatch mutiple action got it wrong
          // TODO: How to chain async actions https://github.com/reduxjs/redux/issues/1676
          await dispatch(
            issueActions.updateProcessStatus({
              issue_id,
              status_id,
              params: memoGetIssueDetailPackage,
              options: { includedViewStatus: true },
            })
          ).then(
            // Addition: dispatch action-updateIssueLog
            () =>
              dispatch(
                issueLogActions.updateIssueLog(memoGetListActivityPackage)
              ).catch((error) => {
                throw error;
              }),
            (error) => {
              throw error;
            }
          );

          // If change status to recieved the api update to processing auto.
          // Take processStatus_id after updated assign to processStatus_idRef (It chaange value props for re-reder ButtonGroupSelectOptions)
          // processStatus_idRef.current = issue.issues.processStatus_id;
          enqueueSnackbar(`เปลี่ยนสถานะแล้ว`, {
            variant: 'success',
          });
        } catch (error) {
          btnSelectOptionsRef.current.undoSelected();
          handleClientError(error);
        }
      }
    };

    /******************************
     * DIMESION APP FUCNTION
     ******************************/

    /**
     * handleDimensionChange()
     * @param {*} e event
     * @param {*} v value
     * @returns
     */
    async function handleDimensionChange(e, v) {
      let dimensions = [
        {
          dimension_id: v.dimension_id,
          dimensionLevel_id: v.dimensionLevel_id,
        },
      ];
      try {
        // Dispatch mutiple action (updateIssueDimension, updateIssueLog) with solution 2 (Look solution 1 in handleChangeProcessStatus)
        await dispatch(
          issueActions.updateIssueDimension({
            id: issue_id,
            dimensions,
            params: memoGetIssueDetailPackage,
            options: { includedViewStatus: true },
          })
        ).then(
          // Addition: dispatch action-updateIssueLog
          () =>
            dispatch(
              issueLogActions.updateIssueLog(memoGetListActivityPackage)
            ).catch((error) => {
              throw error;
            }),
          (error) => {
            throw error;
          }
        );

        enqueueSnackbar(
          `ปรับปรุง ${v.dimension_name} = ${v.dimensionLevel_name} แล้ว`,
          {
            variant: 'success',
          }
        );
      } catch (error) {
        handleClientError(error);
      }
    }

    /*****************************
     * FORWARD ISSUE APP FUCNTION
     ******************************/
    /**
     * handleSubmitForwardIssue
     * @param {object} props
     * @param {object} issueForwarding , issue object included forwarding data.
     * @param {object} comment , comment data
     */
    async function handleSubmitForwardIssue({ issue, comment }) {
      try {
        // Dispatch mutiple action (updateIssue, updateIssueLog) solution 2
        // Ref: https://github.com/reduxjs/redux-thunk
        // Ref: https://twitter.com/dan_abramov/status/770914221638942720

        await dispatch(
          issueActions.forwardIssue({
            data: issue,
            params: memoGetIssueDetailPackage,
            options: { includedViewStatus: true },
          })
        )
          .then(
            () =>
              dispatch(
                issueCommentActions.addIssueComment({
                  issue_id,
                  data: comment,
                  params: memoGetListActivityPackage,
                })
              ),
            (error) => {
              throw error;
            }
          )
          .then(
            // Addition: dispatch action-updateIssueLog
            () =>
              dispatch(
                issueLogActions.updateIssueLog(memoGetListActivityPackage)
              ).catch((error) => {
                throw error;
              }),
            (error) => {
              throw error;
            }
          );
        setOpenFormForward(false);
      } catch (error) {
        handleClientError(error);
      }
    }

    /****************************
     * LABEL APP FUCNTION
     ***************************/

    async function handleBlurLabelPicker(
      pendingLabels,
      existingLabels,
      updateLabelPendingToSelectedState
    ) {
      // check if pendingLabels and existingLabels equal or not, if Equal then prosess api.
      if (JSON.stringify(pendingLabels) !== JSON.stringify(existingLabels)) {
        let labels = pendingLabels.map((label) => ({
          label_id: label.id,
        }));
        try {
          // Dispatch mutiple action (updateIssueDimension, updateIssueLog) with solution 2
          await dispatch(
            issueActions.updateIssueLabel({
              id: issue_id,
              labels,
              params: memoGetIssueDetailPackage,
              options: { includedViewStatus: true },
            })
          ).then(
            // Addition: dispatch action-updateIssueLog
            () =>
              dispatch(
                issueLogActions.updateIssueLog(memoGetListActivityPackage)
              ).catch((error) => {
                throw error;
              }),
            (error) => {
              throw error;
            }
          );
          enqueueSnackbar(`ปรับปรุงป้ายกำกับแล้ว`, {
            variant: 'success',
          });
          updateLabelPendingToSelectedState &&
            updateLabelPendingToSelectedState();
        } catch (error) {
          handleClientError(error);
        }
      } else {
        // enqueueSnackbar(`ไม่มีการติดป้ายกำกับเพิ่ม`, {
        //   variant: 'warning',
        // });
      }
    }

    /****************************
     * OBSERVER APP FUCNTION
     ****************************/

    // Check this use is obsered issue.
    let userObserved = useMemo(
      () =>
        issue.observers
          ? issue.observers.find((osv) => osv.users.id === upf.user.id)
          : undefined,
      [issue.observers]
    );

    // Dialog display overservers
    const [observing, setObserving] = useState(false);
    const [openObserver, setOpenObserver] = React.useState(false);
    const [openConfirmUnObserve, setOpenConfirmUnObserve] = React.useState(
      false
    );

    const handleOpenObserverDialog = () => {
      setOpenObserver(true);
    };

    const handleCloseObserverDialog = () => {
      setOpenObserver(false);
    };

    const handleOpenConfirmUnObserve = () => {
      setOpenConfirmUnObserve(true);
    };

    const handleCloseConfirmUnObserve = () => {
      setOpenConfirmUnObserve(false);
    };

    const handleUnObserve = () => {
      manageObserving({ mode: 'remove' });
      handleCloseConfirmUnObserve();
    };

    const handleSetObserve = () => {
      manageObserving({ mode: 'add' });
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
      if (openObserver) {
        const { current: descriptionElement } = descriptionElementRef;
        if (descriptionElement !== null) {
          descriptionElement.focus();
        }
      }
    }, [openObserver]);

    async function manageObserving({ mode = 'add' }) {
      let data = {
        issue_id,
        user_id: upf.user.id,
      };
      mode === 'add' && setObserving(true);
      try {
        // Dispatch mutiple action
        await dispatch(
          mode === 'add'
            ? issueActions.addObserver({
                ...data,
                params: memoGetIssueDetailPackage,
                options: { includedViewStatus: true },
              })
            : issueActions.removeObserver({
                ...data,
                params: memoGetIssueDetailPackage,
                options: { includedViewStatus: true },
              })
        ).then(
          // Addition: dispatch action-updateIssueLog
          () =>
            dispatch(
              issueLogActions.updateIssueLog(memoGetListActivityPackage)
            ).catch((error) => {
              throw error;
            }),
          (error) => {
            throw error;
          }
        );
        enqueueSnackbar(`${mode === 'remove' ? 'เลิก' : ''}ติดตามแล้ว`, {
          variant: 'success',
        });
      } catch (error) {
        handleClientError(error);
      }

      mode === 'add' && setObserving(false);
    }

    return (
      <div className={classes.root}>
        {/* Category */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.observers && (
          <Fragment>
            <div className={classes.section1}>
              {userObserved ? (
                <Fragment>
                  <LFTooltip
                    title={`ติดตามในฐานะ ${
                      userObserved.observers.type === 0 ? 'คณะทำงาน' : 'ทั่วไป'
                    }`}
                  >
                    <Button
                      color="default"
                      variant="contained"
                      size="small"
                      onClick={handleOpenConfirmUnObserve}
                    >
                      ติดตามแล้ว
                    </Button>
                  </LFTooltip>
                </Fragment>
              ) : (
                <Button
                  color="secondary"
                  variant="contained"
                  size="small"
                  disabled={observing}
                  onClick={handleSetObserve}
                >
                  ติดตาม
                </Button>
              )}

              {issue.observers.length > 0 && (
                <Fragment>
                  {' '}
                  <LFTooltip title="ผู้ติดตามทั้งหมด">
                    <Button onClick={handleOpenObserverDialog} size="small">
                      ผู้ติดตาม
                    </Button>
                  </LFTooltip>{' '}
                </Fragment>
              )}
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.categorys && (
          <Fragment>
            <div className={classes.section1}>
              <Typography variant="body2" component="p">
                <Box fontWeight="fontWeightBold" mb={1}>
                  ประเภทของข้อมูลส่วนบุคคล
                </Box>
                <Box mb={1}>{issueTransition(issue.categorys.name)}</Box>
                <Box fontWeight="fontWeightBold" mb={1}>
                  ระดับ {issueTransition(issue.issues.level)}
                </Box>
              </Typography>
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}

        {/* Reporter */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.issues && (
          <Fragment>
            <div className={classes.section1}>
              <Typography variant="body2" component="p">
                <Box fontWeight="fontWeightBold" mb={0.5}>
                  ผู้แจ้ง{' '}
                  <LFTooltip title="รายละเอียด" placement="top">
                    <IconButton
                      aria-label="reporter info"
                      size="small"
                      onClick={() => {
                        let x = document.getElementById('reporter-info');
                        if (x.style.display === 'none') {
                          x.style.display = 'block';
                        } else {
                          x.style.display = 'none';
                        }
                      }}
                    >
                      <InfoOutlinedIcon style={{ fontSize: 20 }} />
                    </IconButton>
                  </LFTooltip>
                </Box>
              </Typography>
              <Typography variant="body2" component="div">
                {issue.issues.fullname && (
                  <div>ชื่อ: {issue.issues.fullname}</div>
                )}
                <div id="reporter-info" style={{ display: 'none' }}>
                  {issue.issues.email && <div>อีเมล: {issue.issues.email}</div>}
                  {issue.issues.position && (
                    <div>ตำแหน่ง: {issue.issues.position}</div>
                  )}
                  {issue.issues.department && (
                    <div>ส่วนงาน: {issue.issues.department}</div>
                  )}
                </div>
              </Typography>
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}

        {/* ProcessStatus */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.issues && (
          <Fragment>
            <div className={classes.section1}>
              <Typography variant="body2" component="div">
                <Box fontWeight="fontWeightBold" mb={1}>
                  สถานะการดำเนินการ
                </Box>
              </Typography>
              {isManageIssue(
                issue.readOnlyStatus.readOnly,
                issue.issues.worker === upf.user.id,
                issue.issues.processStatus_id,
                {
                  operation: issueOperations.reciever,
                }
              ) ? (
                <ButtonGroupSelectOptions
                  ref={btnSelectOptionsRef}
                  options={processStatuses}
                  hiddenOption={(option) => {
                    return !processStatusesBiz
                      .map((item) => item.id)
                      .includes(option.id);
                  }}
                  disabledOption={(option) => option.id === 99}
                  value={issue.issues.processStatus_id}
                  onChange={handleChangeProcessStatus}
                />
              ) : (
                <Chip
                  className={classes.chipStatusMediumStyle}
                  style={
                    issue.processStatuses &&
                    JSON.parse(issue.processStatuses.style)
                  }
                  label={issue.processStatuses && issue.processStatuses.name}
                />
              )}
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}
        {/* FormForwardIssueDialog */}
        <div style={{ display: 'none' }}>
          {issue.issues && (
            <FormForwardIssueDialog
              id={issue.issues.id}
              categoryId={issue.issues.category_id}
              level={issue.issues.level}
              permissionGroupFilter={issue.issues.permissionGroupFilter}
              open={openFormForward}
              onSubmit={handleSubmitForwardIssue}
              onCancel={() => {
                btnSelectOptionsRef.current.undoSelected();
                setOpenFormForward(false);
              }}
            />
          )}
        </div>

        {/* Worker */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.issueWorker && (
          <Fragment>
            <div className={classes.section1}>
              <Typography variant="body2" component="p">
                <Box fontWeight="fontWeightBold" mb={0.5}>
                  ผู้รับเรื่อง
                </Box>
                <Box fontWeight="fontWeight" mb={0.5}>
                  {`${issue.issueWorker.firstName} ${issue.issueWorker.lastName}`}
                </Box>
                {/* <Box fontWeight="fontWeightBold" mb={0.5}>
                {issueTransition(issueReducer.permissionGroup_name)}
              </Box> */}
              </Typography>
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.viewStatus && (
          <Fragment>
            {issue.viewStatus.filterGroup && (
              <Fragment>
                <div className={classes.section1}>
                  <Typography variant="body2" component="p">
                    <Box fontWeight="fontWeightBold" mb={0.5}>
                      <PeopleAltOutlinedIcon
                        fontSize="small"
                        style={{ verticalAlign: 'middle' }}
                        color="primary"
                      />
                      ระบุกลุ่มผู้ดูแล-ดำเนินการ
                      <HtmlTooltip
                        title={
                          <React.Fragment>
                            <Typography>
                              <Box fontSize={16}>
                                มีการส่งต่อเรื่องแบบระบุกลุ่มผู้ดูแล-ดำเนินการที่ท่านเป็นสมาชิก
                              </Box>
                              <Box fontSize={14}>
                                ระบุมายังกลุ่ม:{' '}
                                {issue.permissionGroupFilter.name}
                              </Box>
                            </Typography>
                          </React.Fragment>
                        }
                      >
                        <HelpOutlineIcon
                          fontSize="small"
                          style={{ verticalAlign: 'middle' }}
                        />
                      </HtmlTooltip>
                    </Box>
                    <Box mb={0.5}>{issue.permissionGroupFilter.name}</Box>
                  </Typography>
                </div>
                <Divider variant="middle" />{' '}
              </Fragment>
            )}
          </Fragment>
        )}

        {/* Label */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading && issue.issues && (
          <Fragment>
            <div className={classes.section1}>
              {/* issue.issueLabels is array item of {labels. labelTypes} */}
              {isManageFeatures ? (
                <LabelPicker
                  value={
                    issue.issueLabels
                      ? issue.issueLabels.map((issueLabel) => issueLabel.labels)
                      : []
                  }
                  onBlur={handleBlurLabelPicker}
                />
              ) : (
                <React.Fragment>
                  <Typography variant="body2" component="div">
                    <Box fontWeight="fontWeightBold" mb={0.5}>
                      ป้ายกำกับ
                    </Box>
                  </Typography>
                  {issue.issueLabels.length > 0 ? (
                    <ChipLabels
                      labels={issue.issueLabels.map(
                        (issueLabel) => issueLabel.labels
                      )}
                    />
                  ) : (
                    '-'
                  )}
                </React.Fragment>
              )}
            </div>
            <Divider variant="middle" />
          </Fragment>
        )}

        {/* Dimension */}
        {issueReducer.isLoading && <SkeletonText />}
        {!issueReducer.isLoading &&
          issue.issues &&
          dimensions.map((dimension, index) => {
            //find selected dimensionLevel of each dimentsion
            let valueIssueDimensionLevel = null;
            if (issue.issueDimensions.length > 0) {
              let issueDimension = issue.issueDimensions.find(
                (issueDimension) =>
                  issueDimension.dimensions.id === dimension.id
              );

              // Selected option schema value for AutocompleteSelectOptions (props.value)
              valueIssueDimensionLevel = {
                dimension_id: issueDimension.dimensions.id,
                dimension_name: issueDimension.dimensions.name,
                dimensionLevel_id: issueDimension.dimensionLevels.id,
                dimensionLevel_name: issueDimension.dimensionLevels.name,
                dimensionLevel_value: issueDimension.dimensionLevels.value,
              };
            }

            // Options schema for AutocompleteSelectOptions (props.options)
            let levelOptions = dimension.levels.map((level) => ({
              dimension_id: dimension.id,
              dimension_name: dimension.name,
              dimensionLevel_id: level.id,
              dimensionLevel_name: level.name,
              dimensionLevel_value: level.value,
            }));

            return (
              <Fragment key={index}>
                <div className={classes.section1}>
                  <Typography variant="body2" component="div">
                    <Box fontWeight="fontWeightBold" mb={0.5}>
                      {dimension.name}
                    </Box>
                  </Typography>
                  <React.Fragment>
                    {isManageFeatures ? (
                      <AutocompleteSelectOptions
                        options={levelOptions}
                        placeholder={`เลือก ${dimension.name}`}
                        value={valueIssueDimensionLevel}
                        onChange={handleDimensionChange}
                        fieldOptions={{
                          id: 'dimensionLevel_id',
                          title: 'dimensionLevel_name',
                        }}
                        // anather prop
                        disableClearable
                        blurOnSelect
                      />
                    ) : valueIssueDimensionLevel ? (
                      valueIssueDimensionLevel.dimensionLevel_name
                    ) : (
                      '-'
                    )}
                  </React.Fragment>
                </div>
                <Divider variant="middle" />
              </Fragment>
            );
          })}

        <Dialog
          open={openObserver}
          onClose={handleCloseObserverDialog}
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="scroll-dialog-title">
            ผู้ติดตามเหตุละเมิด
          </DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
            >
              {issue.observers && (
                <Fragment>
                  <Box
                    display="flex"
                    flexDirection="row"
                    flexWrap="wrap"
                    bgcolor="background.paper"
                    css={{ maxWidth: '100%', padding: 5 }}
                  >
                    <Box flexGrow={1}>ลำดับ</Box>
                    <Box flexGrow={4}>ผู้ติดตาม</Box>
                    <Box flexGrow={1}>ติดตามในฐานะ</Box>
                  </Box>
                  {issue.observers.map((osv, index) => (

                      <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        bgcolor="background.paper"
                        css={{ maxWidth: '100%', padding: 5 }}
                        key={index}
                      >
                        <Box flexGrow={1}>{index + 1}</Box>
                        <Box
                          flexGrow={4}
                        >{`${osv.users.firstName} ${osv.users.lastName}`}</Box>
                        <Box flexGrow={1}>
                          {osv.observers.type === 0 ? 'คณะทำงาน' : 'ทั่วไป'}
                        </Box>
                      </Box>
                  ))}
                </Fragment>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseObserverDialog} color="primary">
              เสร็จสิ้น
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openConfirmUnObserve}
          onClose={handleCloseConfirmUnObserve}
          aria-labelledby="alert-dialog-confirm-title"
          aria-describedby="alert-dialog-confirm-description"
        >
          <DialogTitle id="alert-dialog-confirm-title">
            ยืนยันการเลิกติดตาม
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              ยืนยันการเลิกติดตามเหตุละเมิดนี้
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              size="small"
              variant="contained"
              onClick={handleUnObserve}
            >
              ยืนยัน
            </Button>
            <Button
              color="default"
              size="small"
              variant="contained"
              onClick={handleCloseConfirmUnObserve}
              autoFocus
            >
              ยกเลิก
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

/**
 * AppSidebarRBack() constist of routes and component in route.
 * @returns
 */
export default function AppSidebarRBack() {
  return (
    <Router>
      <Switch>
        <Route
          path={routers.backOf.issue.path}
          exact={true}
          component={AppSidebarRBackManageIssueActivity}
        />
      </Switch>
    </Router>
  );
}
